<template>

	<div v-if="showDetails" class="mx-auto p-3 sm:p-4">
		<div class="mx-auto">
			<div ref="detailsContent" id="detailsContent" class="text-gray-700">
				<div class="btn-grup flex justify-between border-b mb-3 pb-3">
					<div class="flex items-center gap-3">
						<button
							class="flex flex-row hover:bg-gray-4 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold hover:text-primary-500 transition-all bg-transparent border-gray-3 border text-primary"
							type="button"
							@click="handleBackButtonClick"
						>
							<i class="tabler:arrow-left w-5 h-5 mr-1"></i>
							<span class="hidden md:inline">{{ labels.backbtn }}</span>
						</button>
					</div>
					<div class="flex">
							<LanguageSwitcher class="mr-3"  :languages="languageList" :hideLabel="false" />
							<PlayerButton
								v-if=" !collectionModeData?.hideReadittomeButton"
								:file_url="post?.file_url || ''"
								:isPlaying="playingId === post?.identifier"
								:language="requestedLng"
								:autoSuspend="false"
								@togglePlayback="handleTogglePlayback(post?.identifier ?? '')"
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
							/>
							<EditButton
								v-if="collectionModeData?.editmode && post?.identifier"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier"
								type="podcast"
								:overrideURL="post?._links.podcastSlideshowConversations?.href"
							/>

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white ml-2"
								type="button"
								v-if=" !collectionModeData?.hidePresentationButton "
								:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
								@click="goToPresenation"
							>
								<i class="tabler:presentation w-5 h-5 mr-1"></i>

								<span class="hidden md:inline">{{ labels.presentation }}</span>
							</button>
							<EditButton
								v-if="collectionModeData?.editmode && post?.identifier"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier"
								type="podcast"
								:overrideURL="post?._links.podcastSlideshow?.href"
							/>

						<button
							class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
							:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
							type="button"
							v-if="!collectionModeData?.hidePostQuizButton"
							@click="modalVisiblePostQuiz = true"
						>
							<i class="tabler:list-details w-5 h-5 mr-1"></i>
							<span class="hidden md:inline">{{ labels.postquiz }}</span>
						</button>
						<EditButton
							v-if="collectionModeData?.editmode && post?._links.postQuiz?.href"
							class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							:id="post?.identifier ?? ''"
							type="postquiz"
							:overrideURL="post?._links.postQuiz?.href"
						/>

						<!-- <button
							class="flex flex-row hover:bg-primary-500/10 items-center rounded ml-2 py-2 px-4 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary text-white"
							type="button"
							@click="preparePrint"
						>
							<i class="tabler:printer w-5 h-5"></i
							><span class="hidden md:inline">{{ labels.prepareprint }}</span>
						</button> -->
						<!-- <EditButton
							class="flex flex-row hover:bg-primary-500/10 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold !hover:text-primary-500 transition-all bg-primary !text-white"
							v-if="collectionModeData?.editmode"
							:id="post?.identifier ?? ''"
							type="slideshow"
						/> -->

					</div>
				</div>
				<DialogModal
					v-model:visible="modalVisiblePostQuiz"
					modal
					:header="labels.postquiz"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="collectionModeData?.editmode"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						type="postquiz"
						:overrideURL="post?._links.postQuiz.href"
					/>
					<PostQuiz :jsonData="post" @close="modalVisiblePostQuiz = false" />
				</DialogModal>

				<DialogModal group="templating">
					<template #message="slotProps">
						<div class="flex flex-col items-center w-full gap-3 border-b-1 pb-3">
							<div
								class="border-rounded-50% border-primary w-50px h-50px border-3px flex items-center justify-center"
							>
								<i :class="slotProps.message.icon" class="text-3xl inline-block text-primary-500"></i>
							</div>
							<p class="text-sm text-gray-700">{{ slotProps.message.message }}</p>
						</div>
					</template>
				</DialogModal>

				<!-- <DialogModal
                    v-model:visible="showQuiz"
                    maximizable
                    modal
                    header="Test your Knowledge"
                    :style="{ width: '90rem' }"
                    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
                >
                    <PreQuiz @close="showQuiz = false" />
                </DialogModal> -->

				<div class="">
					<EwLoadingOverlay v-if="loading" class="relative inset-0 z-50 flex items-center justify-center" />  

					<section id="section1" class="mb-8">
						<div class="flex justify-end p-3">
							<button
								type="button"
								class="flex flex-row items-center justify-center items-center text-center font-sans text-xs transition-all block md:hidden text-primary-500"
								@click="showGallery = !showGallery"
							>
								<i class="tabler:photo-up w-5 h-5"></i>
							</button>
						</div>

						<div class="flex flex-row sm:flex-column justify-center px-4 flex-wrap" v-if="post">
							<div id="twoCol" v-if="post?.mainOutcome?.sectionLayout != 'oneCol'" class="flex flex-row sm:flex-column justify-center flex-wrap">
							<div class="pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg hidden sm:block">
								<div class="flex items-center gap-2 justify-end mb-3">
									<EditButton
										class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
										type="newImage"
										v-if="collectionModeData?.editmode"
										:id="post?.identifier ?? ''"
										:overrideURL="post?._links.illustration.href"
									/>
									<EditButton
										class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
										v-if="collectionModeData?.editmode"
										:id="post?.identifier ?? ''"
										type="imagelist"
										:overrideURL="post?._links.illustration.href"
									/>
								</div>

								<div v-if="post?.illustration && post.illustration.length != 0 && post.mainOutcome.sectionLayout != 'oneCol'" class="relative">
									<ImageGallery :jsonData="post" :collectionModeData="collectionModeData"></ImageGallery>
								</div>
								<div v-else>
									<InteractiveImage alt="Image" preview>
										<template #indicatoricon>
											<i class="tabler:eye w-8 h-8 text-white"></i>
										</template>
										<template #image>
												<img
													v-if="!isImageError"
													:src="post?.mainOutcome.imageSrc"
													alt="image"
													@load="isImageLoaded = true"
													@error="isImageError = true"
													class="transition-opacity duration-300 !max-h-[720px]"
													:class="{ 'opacity-0': !isImageLoaded }"
												/>

												<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>

										</template>
										<template #preview="slotProps">
											<div class="p-5">
												<img
													:src="post?.mainOutcome.imageSrc"
													alt="preview"
													class="mx-auto"
													:style="slotProps.style"
													@click="slotProps.onClick"
												/>
												<p class="text-sm italic text-white mt-8 text-left">
													{{ post?.mainOutcome.imageTitle }}
												</p>
											</div>
										</template>
									</InteractiveImage>
									<div class="text-left italic text-sm">
										{{ post?.mainOutcome.imageTitle }}
									</div>
								</div>
							</div>
							<div class="md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
							
								<div class="main-text relative">
									<EditButton
										v-if="collectionModeData?.editmode"
										class="absolute right-0 top-[-10px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										:id="post?.identifier ?? ''"
										:overrideURL="post._links.mainOutcome.href"
										type="details"
									/>
									<InplaceEdit
										:inputProps="[{ content: post.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
										:href="post._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData">
										<h6
											class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
											{{ post.mainOutcome.selectHeader }}
										</h6>
									</InplaceEdit>
									<div class="flex items-center">

												<InplaceEdit
													:inputProps="[
														{
															content: post.mainOutcome.title,
															propName: 'title',
															inputType: 'textarea',
														},
													]"
													:href="post._links.mainOutcomeEdit.href"
													:showAssistant="true"
													:collectionMode="collectionModeData"
													blockTitle="Edit title"
													:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
												>
													<h4
														class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
													>
														{{ post.mainOutcome.title }}
													</h4>
												</InplaceEdit>
									</div>
									<div class="gap-3 flex items-center">
										<InplaceEdit
											v-if="collectionModeData?.id != 'language_review'"
											:collectionMode="collectionModeData"
											:inputProps="[
												{
													content: post.mainOutcome.publishingDate,
													propName: 'other.publishingDate',
													inputType: 'datepicker',
												},
											]"
											:href="post._links.mainOutcomeEdit.href"
											blockTitle="Edit publishing date"
										>
											<div class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>
										</InplaceEdit>
										<div v-else class="text-sm inline-flex items-center pt-1 my-1">
											{{ publishingDateFormated }}
										</div>
										<InplaceEdit
											:collectionMode="collectionModeData"
											v-if="collectionModeData?.id != 'language_review'"
											:inputProps="[
												{
													content: post.mainOutcome.authorIdentifier,
													propName: 'other.authorIdentifier',
													inputType: 'select',
													selectProps: {
														optionValue: 'identifier',
														optionLabel: 'title',
														class: 'w-15rem',
														optionsCvKey: 'author',
													},
												},
											]"
											:href="post._links.mainOutcomeEdit.href"
											blockTitle="Edit author"
										>
											<div class="ml-2 text-sm font-bold" v-html="post.mainOutcome.author"></div>
										</InplaceEdit>
										<div v-else class="ml-2 text-sm font-bold" v-html="post.mainOutcome.author"></div>
									</div>
									<div v-if="post?.mainOutcome.leadText" class="relative py-3">
										<strong class="mb-4">{{ labels.leadText }}</strong>
										<div id="editLeadText" class="flex items-end relative">
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="post?.mainOutcomeBl?.leadText"
												:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
												:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
												<div v-html="post?.mainOutcome.leadText"></div>
											</InplaceEdit>
										</div>
									</div>
									<div id="editKeyMessages" class="relative mt-3 py-4" v-if="post?.mainOutcome.keyMessages">
										<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && post.identifier"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div id="editKeyMessagges" class="py-5 px-2">
														<InplaceEdit
															:collectionMode="collectionModeData"
															:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
															:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
															<div v-html="post?.mainOutcome.keyMessages"></div>
														</InplaceEdit>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div v-for="(section, index) in post.mainOutcome.main_text" :key="index">
										<InplaceEdit
											:collectionMode="collectionModeData"
											:inputProps="[
												{ content: section.heading, inputType: 'input', propName: 'heading' },
												{ content: section.content, inputType: 'editor', propName: 'content' },
											]"
											method="PUT"
											:href="section._links.self.href"
											blockTitle="Edit section"
											:showAssistant="true"
										>
											<div class="my-2">
												<div class="text-sm">
													<strong class="block">{{ section.heading }}</strong>
													<div v-html="section.content"></div>
												</div>
											</div>
										</InplaceEdit>
									</div>
									</div>
								</div>
								<div class="relative mt-3 py-4">
									<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
									<EditButton
										v-if="collectionModeData?.editmode && post.identifier"
										class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										:id="post?.identifier ?? ''"
										:overrideURL="post._links.mainOutcome.href"
										type="references"
									/>

									<div id="references" class="shadow-sm border rounded-lg">
										<div class="flex justify-between items-center">
											<div class="sorces relative border-secondary w-full">
												<div
													class="py-5 px-2 mx-4"
													v-if="
														post?.mainOutcome.references &&
														post.mainOutcome.references.length > 0
													"
												>
													<ol class="list-decimal">
														<li
															v-for="(referenceItem, index) in post?.mainOutcome
																.references"
															:key="index"
															class="text-sm"
														>
														<div class="flex items-center py-1">
																<InplaceEdit
																	:collectionMode="collectionModeData"
																	:inputProp="
																		{
																			content: referenceItem,
																			propName: 'other',
																			removeProps: ['pdfLink', '_links'],
																			inputType: 'references',
																		}
																	"
																	method="PATCH"
																	:href="referenceItem._links?.self.href"
																	:showSwitch="true"
																	blockTitle="Edit Refrence"
																>
																
																	<span v-if="referenceItem.journal">
																		{{ referenceItem.journal }}
																	</span>
																	<span v-if="referenceItem.year">
																		{{ referenceItem.year }},
																	</span>

																	<span
																		v-if="
																			referenceItem.nameDOI || referenceItem.linkDOI
																		"
																		class="font-semibold"
																	>
																		{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																		<a
																			:href="
																				referenceItem.nameDOI
																					? `https://doi.org/${referenceItem.nameDOI}`
																					: referenceItem.linkDOI
																			"
																			target="_blank"
																			class="text-primary"
																		>
																			{{
																				referenceItem.nameDOI
																					? `${referenceItem.nameDOI}`
																					: referenceItem.linkDOI
																			}}
																		</a>
																	</span>
																	<span
																		v-if="
																			(referenceItem.nameDOI ||
																				referenceItem.linkDOI) &&
																			referenceItem.title
																		"
																		>,
																	</span>
																	<span
																		v-if="referenceItem.title"
																		class="ml-1 font-semibold"
																		>&laquo;{{ referenceItem.title }}&raquo;</span>
																</InplaceEdit>
																<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer">
																	<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																</a>
																<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																	<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																</a> -->
																<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

															</div>
														</li>
													</ol>
												</div>
												<div v-else class="p-5 bg-gray-100 flex items-center">
													<div class="text-center text-danger text-xs inline-flex mx-auto">
														<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div id="oneCol" v-else class="flex flex-wrap">
								<div class="flex flex-row sm:flex-column justify-center flex-wrap">
									<div class="pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg hidden sm:block">
										<div class="flex items-center gap-2 justify-end mb-3">
											<EditButton
												class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
												type="newImage"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												:overrideURL="post?._links.illustration.href"
											/>
											<EditButton
												class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												type="imagelist"
												:overrideURL="post?._links.illustration.href"
											/>
										</div>

										<div v-if="post?.illustration && post.illustration.length != 0" class="relative">
											<ImageGallery :jsonData="post" :collectionModeData="collectionModeData"></ImageGallery>
										</div>
										<div v-else>
											<InteractiveImage alt="Image" preview>
												<template #indicatoricon>
													<i class="tabler:eye w-8 h-8 text-white"></i>
												</template>
												<template #image>
														<img
															v-if="!isImageError"
															:src="post?.mainOutcome.imageSrc"
															alt="image"
															@load="isImageLoaded = true"
															@error="isImageError = true"
															class="transition-opacity duration-300 !max-h-[720px]"
															:class="{ 'opacity-0': !isImageLoaded }"
														/>

														<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
												</template>
												<template #preview="slotProps">
													<div class="p-5">
														<img
															:src="post?.mainOutcome.imageSrc"
															alt="preview"
															class="mx-auto"
															:style="slotProps.style"
															@click="slotProps.onClick"
														/>
														<p class="text-sm italic text-white mt-8 text-left">
															{{ post?.mainOutcome.imageTitle }}
														</p>
													</div>
												</template>
											</InteractiveImage>
											<div class="text-left italic text-sm">
												{{ post?.mainOutcome.imageTitle }}
											</div>
										</div>
									</div>
									<div class="md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
										<InplaceEdit
											:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
											:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
											:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl?.selectHeader">
											<h6
												class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
												{{ post?.mainOutcome.selectHeader }}
											</h6>
										</InplaceEdit>
										<div class="flex items-center">
											<InplaceEdit
												:inputProps="[
													{
														content: post?.mainOutcome.title,
														propName: 'title',
														inputType: 'textarea',
													},
												]"
												:href="post?._links.mainOutcomeEdit?.href"
												:showAssistant="true"
												:enableCollapseSection="true"
												:extraContent="post?.mainOutcomeBl?.title"
												:collectionMode="collectionModeData"
												blockTitle="Edit title"
												:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
											>
												<h4
													class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
												>
													{{ post?.mainOutcome.title }}
												</h4>
											</InplaceEdit>
										</div>
										<div class="gap-3 flex items-center">
											<InplaceEdit
												v-if="collectionModeData?.id != 'language_review'"
												:collectionMode="collectionModeData"
												:inputProps="[
													{
														content: post?.mainOutcome.publishingDate,
														propName: 'other.publishingDate',
														inputType: 'datepicker',
													},
												]"
												:href="post?._links.mainOutcomeEdit?.href"
												blockTitle="Edit publishing date"
											>
												<div class="text-sm inline-flex items-center pt-1 my-1">
													{{ publishingDateFormated }}
												</div>
											</InplaceEdit>
											<div v-else class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>

											<InplaceEdit
												:collectionMode="collectionModeData"
												v-if="collectionModeData?.id != 'language_review'"
												:inputProps="[
													{
														content: post?.mainOutcome.authorIdentifier,
														propName: 'other.authorIdentifier',
														inputType: 'select',
														selectProps: {
															optionValue: 'identifier',
															optionLabel: 'title',
															class: 'w-15rem',
															optionsCvKey: 'author',
														},
													},
												]"
												:href="post?._links?.mainOutcomeEdit?.href || ''"
												blockTitle="Edit author"
											>
												<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
											</InplaceEdit>
											<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</div>
										<div v-if="post?.mainOutcome.leadText" class="relative py-3">
											<strong class="mb-4">{{ labels.leadText }}</strong>
											<div id="editLeadText" class="flex items-end relative">
												<InplaceEdit
													:collectionMode="collectionModeData"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl?.leadText"
													:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
													:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
													<div v-html="post?.mainOutcome.leadText"></div>
												</InplaceEdit>
											</div>
										</div>
									</div>	
								</div>
								<div :class="sectionLayoutClass">
									<div id="editKeyMessages" class="relative py-4" v-if="post?.mainOutcome.keyMessages">
										<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
										<div class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div id="editKeyMessagges" class="py-5 px-2">
														<InplaceEdit
															:collectionMode="collectionModeData"
															:enableCollapseSection="true"
															:extraContent="post?.mainOutcomeBl?.keyMessages"
															:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
															:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
															<div v-html="post?.mainOutcome.keyMessages"></div>
														</InplaceEdit>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="main-text relative">
										<div v-for="(section, index) in post?.mainOutcome.main_text" :key="index" >
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="post?.mainOutcome.references && post.mainOutcome.references.length > 0" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div class="py-5 px-2 mx-4">
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PATCH"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>
																		<span
																			v-if="referenceItem.nameDOI || referenceItem.linkDOI"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="referenceItem.nameDOI ? `https://doi.org/${referenceItem.nameDOI}` : referenceItem.linkDOI"
																				target="_blank"
																				class="text-primary"
																			>
																				{{ referenceItem.nameDOI ? `${referenceItem.nameDOI}` : referenceItem.linkDOI }}
																			</a>
																		</span>
																		<span
																			v-if="(referenceItem.nameDOI || referenceItem.linkDOI) && referenceItem.title"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																</div>
															</li>
														</ol>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>


								<div v-if="!isTextOnlyOutput" class="audio-player relative mb-4 mt-3 pt-3">
									<h3 class="font-bold text-md mb-5">{{ labels.playlabel }}</h3>
									<EditButton
										v-if="collectionModeData?.editmode"
										class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
										:id="post?.identifier ?? ''"
										type="podcast"
										:overrideURL="post?._links?.podcastSlideshowConversations?.href"
									/>

									<SoundPlayer
									:jsonData="post"
									:file_url="post?.file_url || ''"
									:autoSuspend="false"
									/>
								</div>
								<div class="mt-1">
									<RatingItems :jsonData="post" />
								</div>
							</div>
					</section>
				</div>
			</div>
		</div>
	</div>
	<router-view v-slot="{ Component, route }">
    	<component :is="Component" :selectedLanguage="currentLng" :id="route.params.id" v-bind="presentationDataDetails"/>
  	</router-view>


</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useEventBus } from '@vueuse/core';
import axios from 'axios'
import ImageGallery from '../components/ImageGallery.vue';
import LanguageSwitcher from '../components/LanguageSwitcher.vue';
import PlayerButton from '../components/PlayerButton.vue';
import SoundPlayer from '../components/SoundPlayer.vue';
import RatingItems from '../components/RatingItems.vue';
import PostQuiz from '../components/PostQuiz.vue';
import EditButton from '../components/EditButton.vue';
import { useAppConfig } from '@/composables/useAppConfig';
import { getSpecificPostParams } from '@/utils';
import { messages } from '@/assets/language';
import type { configCollectionMode, CVResponse, LanguageItem, Post, PostDetailsResponse } from '@/types';
import { DateTime } from 'luxon';
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue';
import { CVDataProvided } from '@/types/cvTypes';
import { useAppStore } from '@/stores/app-store'
import EwLoadingOverlay from '@/components/EwLoadingOverlay.vue';

const isImageLoaded = ref(false);
const isImageError = ref(false);
const loading = ref( false );



const route = useRoute();
const router = useRouter();
const bus = useEventBus<Record<string, any>>('saved');
const { currentLng, currentCollectionMode, 	currentTestyourself, currentPAGE_REQ_ID } = useAppStore()

const AppConfig = useAppConfig();
watch([currentLng, () => route.query.lng], ()=>{
	fetchDataPost()
})

function onPropSaved(event: Record<string, any>) {
	console.log(event);
	fetchDataPost();
}
const unsubscribe = bus.on(onPropSaved);

const CVData = ref<CVResponse>({ data: {} });
provide(CVDataProvided, CVData);

// const selectedLanguage = computed( () => ( route.query.lng ) );
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});

const props = defineProps<{
  selectedLanguage?: string;
}>();


const postId = route.params.id as string;

const post = ref<Post | null>(null);
const detailsContent = ref<HTMLElement | null>(null);
const collectionModeData = ref<configCollectionMode | null>(null);
const sectionLayoutClass = computed(() => {
	const layout = post.value?.mainOutcome?.sectionLayout;

	if (layout === 'oneCol') {
		return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
	}
	if (layout === 'twoCol') {
		return 'md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1';
	}

	return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
});


//const jsonData = ref<Post | null>( null );
const modalVisiblePostQuiz = ref(false);
// const modalVisiblePreQuiz = ref(false);

const showGallery = ref(false);

// * Check if the output should be text only. Set in URL query string as `textonly=true`. This will hide the audio player and presentation player buttons
const isTextOnlyOutput = ref<boolean>(!!getSpecificPostParams('textonly', window.location.search));

const getFirstQueryString = (value: unknown): string => {
	if (typeof value === 'string') {
		return value.trim();
	}
	if (Array.isArray(value)) {
		const firstString = value.find((entry) => typeof entry === 'string' && entry.trim().length > 0);
		return typeof firstString === 'string' ? firstString.trim() : '';
	}
	return '';
};

const requestedLng = computed(() => {
	const lngFromStore = String(currentLng.value ?? '').trim();
	if (lngFromStore) {
		return lngFromStore;
	}
	const lngFromRoute = getFirstQueryString(route.query.lng);
	if (lngFromRoute) {
		return lngFromRoute;
	}
	const lngFromProps = String(props.selectedLanguage ?? '').trim();
	if (lngFromProps) {
		return lngFromProps;
	}
	return String(currentLng.value ?? '').trim();
});

function goToPresenation () {
	router.push( { name: 'details-presenation', query: {...route.query}} );
}

const presentationDataDetails = computed(() => {
	if(route.name === 'details-presenation' && route.params.id) {
		return post.value ? { viewUrl: post.value._links.podcastSlideshowEdit?.href, editUrl: post.value._links.podcastSlideshow?.href} : null
	}
	return null
})

const showDetails = computed(() => route.name === 'details')

const languageList = computed(() => CVData.value?.data?.language ?? []);


const preparePrint = () => {
	router.push({
		name: 'prepare-print',
	});
};

const publishingDateFormated = computed(() => {
	const publishingDate = post.value?.mainOutcome.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const openModal = (index: number) => {
  // Merr PDF linkun bazuar në index
  const pdfLink = post.value?.mainOutcome.references[index]?.pdfLink;

  if (!pdfLink) {
    console.error('PDF Link is not available.');
    return;
  }

  // Ndërto URL-në për iframe
  const viewerUrl = `/example/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfLink)}`;

  // Hap modalin duke përdorur Bootstrap API
  const modal = new bootstrap.Modal(document.getElementById('pdfViewer') as HTMLElement);
  modal.show();

  // Vendos URL-në në iframe
  const iframe = document.getElementById('pdfIframe') as HTMLIFrameElement;
  if (iframe) {
    iframe.src = viewerUrl; // Vendos URL-në e ndërtuar
  }
};

const getLngFromIllustrationUrl = (rawUrl: string | null | undefined): string => {
	const value = String(rawUrl ?? '').trim();
	if (!value) {
		return '';
	}

	try {
		const url = new URL(value, window.location.origin);
		return String(url.searchParams.get('lng') ?? '').trim().toLowerCase();
	} catch {
		const match = value.match(/[?&]lng=([^&#]+)/i)?.[1] ?? '';
		if (!match) {
			return '';
		}
		try {
			return decodeURIComponent(match).trim().toLowerCase();
		} catch {
			return match.trim().toLowerCase();
		}
	}
};

const filterIllustrationsByLng = (illustrations: any[] | undefined, lng: string): any[] => {
	if (!Array.isArray(illustrations) || !lng) {
		return [];
	}

	const normalizedLng = lng.trim().toLowerCase();
	if (!normalizedLng) {
		return [];
	}

	const parsed = illustrations.map((item) => {
		const lngFromEdit = getLngFromIllustrationUrl(item?.imageSrcEdit);
		const lngFromSrc = getLngFromIllustrationUrl(item?.imageSrc);
		const itemLng = lngFromEdit || lngFromSrc;
		return { item, itemLng };
	});

	const hasLanguageTaggedItems = parsed.some(({ itemLng }) => Boolean(itemLng));
	if (!hasLanguageTaggedItems) {
		return illustrations;
	}

	const matching = parsed.filter(({ itemLng }) => itemLng === normalizedLng).map(({ item }) => item);
	if (matching.length === 0) {
		return [];
	}

	return parsed
		.filter(({ itemLng }) => itemLng === normalizedLng || !itemLng)
		.map(({ item }) => item);
};

const canonicalizeImageUrl = (rawUrl: string | null | undefined): string => {
	const value = String(rawUrl ?? '').trim();
	if (!value) {
		return '';
	}

	try {
		const url = new URL(value, window.location.origin);
		return `${url.origin}${url.pathname}`;
	} catch {
		return value.split(/[?#]/)[0]?.trim() ?? '';
	}
};

const collectIllustrationObjects = (value: unknown, output: Record<string, any>[]) => {
	if (Array.isArray(value)) {
		value.forEach((entry) => collectIllustrationObjects(entry, output));
		return;
	}

	if (!value || typeof value !== 'object') {
		return;
	}

	const candidate = value as Record<string, any>;
	if (typeof candidate.imageSrc === 'string' || typeof candidate.imageSrcEdit === 'string') {
		output.push(candidate);
	}

	if ('illustrations' in candidate) {
		collectIllustrationObjects(candidate.illustrations, output);
	}
};

const buildIllustrationsFromMainText = (mainText: unknown): any[] => {
	const collected: Record<string, any>[] = [];
	collectIllustrationObjects(mainText, collected);

	if (collected.length === 0) {
		return [];
	}

	const deduped = new Map<string, Record<string, any>>();
	collected.forEach((item, index) => {
		const key =
			canonicalizeImageUrl(item?.imageSrc) ||
			canonicalizeImageUrl(item?.imageSrcEdit) ||
			`fallback-${index}`;
		if (!deduped.has(key)) {
			deduped.set(key, item);
		}
	});

	return Array.from(deduped.values());
};

const getWiItemIdFromHref = (href: string | null | undefined): string | null => {
	if (!href) {
		return null;
	}
	const match = href.match(/\/wi-item\/([^/?#]+)/i);
	return match?.[1] ?? null;
};

const filterItemsByOutcomeId = <T extends Record<string, any>>(items: T[] | undefined, outcomeId: string | null): T[] => {
	if (!Array.isArray(items) || !outcomeId) {
		return Array.isArray(items) ? items : [];
	}
	return items.filter((item) => {
		const href = String(item?._links?.self?.href ?? '');
		if (!href) {
			return false;
		}
		return href.includes(`/wi-item/${outcomeId}/`);
	});
};

const normalizePostIllustrations = (candidate: Post | null): Post | null => {
	if (!candidate) {
		return null;
	}
	const selectedLng = String(requestedLng.value ?? '').trim();
	const desiredOutcomeHref = String((candidate as any)?._links?.languages?.[selectedLng]?.mainOutcome?.href ?? '').trim();
	const desiredOutcomeId =
		getWiItemIdFromHref(desiredOutcomeHref) ||
		String((candidate as any)?.mainOutcome?.id ?? '').trim() ||
		null;
	const baseMainText = (candidate as any)?.mainOutcome?.main_text;
	const filteredMainText = desiredOutcomeId ? filterItemsByOutcomeId(baseMainText, desiredOutcomeId) : [];
	const effectiveMainText = filteredMainText.length > 0 ? filteredMainText : baseMainText;
	const illustrationFromMainText = buildIllustrationsFromMainText(effectiveMainText);
	const topLevelIllustration = Array.isArray((candidate as any).illustration) ? (candidate as any).illustration : [];
	const sourceIllustration = illustrationFromMainText.length > 0 ? illustrationFromMainText : topLevelIllustration;
	const filteredIllustration = filterIllustrationsByLng(sourceIllustration, selectedLng);
	return {
		...candidate,
		mainOutcome: {
			...(candidate as any).mainOutcome,
			main_text: effectiveMainText
		},
		illustration: filteredIllustration
	} as Post;
};


onBeforeUnmount(() => {
	unsubscribe();
});

const fetchDataPost = async () => {
  try {
    loading.value = true;


		let params: Record<string, any> = {
			...route.query,
			lng: requestedLng.value,
			'collection-mode': currentCollectionMode.value,
			testYourself: currentTestyourself.value,
			PAGE_REQ_ID: currentPAGE_REQ_ID.value,
		};

		const response = await axios.get<PostDetailsResponse>( `${AppConfig.urls.getList}?json=y`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': requestedLng.value
			}
		} );


    post.value = normalizePostIllustrations(response.data.data.find((p) => p.identifier === postId) || null);
    CVData.value = response.data.CV;
    collectionModeData.value = response.data.config ?? null;
	console.log('Details Collection Mode', collectionModeData.value)


  } catch (error) {
    console.error('Failed to fetch data:', error);
  } finally {
    loading.value = false;
  }
};




// const handleBackButtonClick = () => {
//   const pageFromQuery = parseInt(route.query.page as string) || 1;
//   router.push({
//     name: 'list',
//     query: {
//       ...route.query,
//       page: pageFromQuery
//     }
//   });
// };
const handleBackButtonClick = () => {
	history.back();
};


const playingId = ref<string | null>(null);

const handleTogglePlayback = (identifier: string) => {
	playingId.value = playingId.value === identifier ? null : identifier;
};

	fetchDataPost();
	loading.value = true;


</script>

<style>
.p-image-action {
	background: #fff;
	margin: 0 10px;
}

#detailsContent ul,
#detailsContent ol {
	list-style: disc;
	margin: 0 25px;
	padding: 0 15px;
}

#detailsContent ol {
	list-style: decimal;
}

#detailsContent #references ol{
	padding:0!important;
	margin:0!important;
}
:deep(.compact-language .p-dropdown-label) {
	padding-right: 0.5rem !important;
	padding-left: 0.25rem !important;
	min-width: auto !important;
}

:deep(.compact-language .fi) {
	margin-right: 0 !important;
}


</style>
